
<template>

    <modal name="PictureMaskWindow" 
           :width="WindowWidth"
           :height="WindowHeight" :scrollable="true"
           :draggable="false"
           @before-open="OnBeforeOpen"
           @before-close="OnBeforeClose"
           @opened="OnOpened">

        <table class="PictureMaskWindow" cellspacing="0" cellpadding="0" border="0" style="border:none" >
            <tr>
                <td class="Header">
                    <t-img src="/static/Image/CloseWhite.png" style="width:30px" 
                         @click="OnCloseButtonClick" 
                         class="CloseDialogButton" ref="CloseDialogButton" />
                </td>
            </tr>
            <tr>
                <td class="" valign="middle" height="90%" style="min-height:100px">

                    <div class="PictureMask">
                        <BlockPagingAnchor PagingBlockSelector=".PictureMask"
                                           ItemListContainerSelector=".PictureItemListContainer"
                                           ItemListSelector=".PictureItemList"
                                           ItemSelector=".PictureItem"
                                           HoverToPicture="true"
                                           ShowPagingButton="true"
                                           :TargetList="PictureItems"
                                           ItemPerPage="1"
                                           PlayMode="Normal"
                                           ref="BlockPagingAnchor"
                                           v-model="PictureIndex" />

                        <div class="PictureItemListContainer">

                            <div class="PictureItemList"> 
                                <div v-for="item in PictureItems" class="PictureItem  "
                                     :style="{'maxHeight':(WindowHeight-100)+'px'}"
                                     >
                                    <t-img :src="item.PicturePath"  :style="{'maxHeight':(WindowHeight-100)+'px'}" />

                                    <div class="Description" v-if="item.Description!=''&&item.Description!=null">{{item.Description}}</div>
                                </div> 
                            </div>
                        </div>
                    </div>

                </td>
            </tr>
            
        </table>


        <component is="style" :key="Key">
            .vm--modal {
                width: 100% !important;
                max-width: {{WindowWidth}}px !important;
                max-height:  {{WindowHeight}}px !important;
                left: 50% !important;
                transform: translateX(-50%) !important;
            }
        </component>
    </modal>


</template>

<script scoped>
    import apiService from '@/Common/ApiService'
    import FormViewRequest from '@/Common/FormViewRequest'
    import Utility from '@/Common/Utility'
    import Validator from '@/Common/Validator'

    export default {
        name: "PictureMaskWindow",
        data() {
            return {
                Key: 0,

                WindowWidth: 1300,
                WindowHeight:800,
                PictureIndex :0,
                ConfirmHandler: null,
                 
                PictureItems : []
            }
        }
        ,
        props: ["value"],

        methods: {


            OnResize() {

                this.WindowWidth = Utility.GetBrowserWidth();
                if (this.WindowWidth > 1300) {
                    this.WindowWidth = 1300;
                }
                this.WindowHeight = Utility.GetBrowserHeight();
                if (this.WindowHeight > 800) {
                    this.WindowHeight = 800;
                }

                this.Key++;
            },

            OnCloseButtonClick() {
                this.$modal.hide("PictureMaskWindow");
            },

            OnConfirmButtonClick() {
                let formViewRequest;
                 
 

                if (this.ConfirmHandler != null) {
                    this.ConfirmHandler(
                        {
                        }
                    );
                }
 
                this.$modal.hide("PictureMaskWindow");
            },

            OnCancelButtonClick() {

                window.removeEventListener("resize", this.OnResize.bind(this));

                this.$modal.hide("PictureMaskWindow");
            },

            OnBeforeOpen(arg) {
                let i;

                this.PictureItems = [];

                if (arg.params.PictureItems !=  null) {
                    this.PictureItems = arg.params.PictureItems;
                }
                 
                if (arg.params.StartPicturePath != null && arg.params.StartPicturePath != "") {
                    for (i = 0; i < this.PictureItems.length; i++) {
                        if (this.PictureItems[i].PicturePath == arg.params.StartPicturePath) {
                            this.PictureIndex = i;
                            break;
                        }
                    }
                }

                this.ConfirmHandler = arg.params.ConfirmHandler;
 
                this.WindowWidth = Utility.GetBrowserWidth();
                if (this.WindowWidth > 1300) {
                    this.WindowWidth = 1300;
                }
                this.WindowHeight = Utility.GetBrowserHeight();
                if (this.WindowHeight > 800) {
                    this.WindowHeight = 800;
                }

                window.addEventListener("resize", this.OnResize.bind(this));


                setTimeout(
                    function () {
                        let windowElement;
                        let modelElement;
                        let left;

                        windowElement = document.querySelector(".PictureMask");

                        if (windowElement != null) {
                            modelElement = Utility.GetParentElementBySelector(windowElement, ".vm--modal");

                            if (modelElement != null) {
                                modelElement.style.backgroundColor = "rgba(0,0,0,0.5)";

                                modelElement.style.width = this.WindowWidth + "px";
                                left = (Utility.GetBrowserWidth() - this.WindowWidth) / 2;

                                modelElement.style.left = left + "px";
                            }

                            //this.$refs.CloseDialogButton.addEventListener("touchstart",
                            //     this.OnCloseButtonClick.bind(this)
                            //);
                        }
                    }.bind(this),
                    1
                );
              
            },

            OnOpened() { 

                setTimeout(
                    function () {
                        let windowElement;
                        let modelElement;

                        windowElement = document.querySelector(".PictureMask");

                        modelElement = Utility.GetParentElementBySelector(windowElement, ".vm--modal");

                        modelElement.style.backgroundColor = "rgba(0,0,0,0.5)";
                    }.bind(this),
                    1
                );
            },

            OnBeforeClose() {
                window.removeEventListener("resize", this.OnResize.bind(this));

                this.$refs.CloseDialogButton.removeEventListener("touchstart",
                    this.OnCloseButtonClick.bind(this)
                );
            } ,
        },

        computed: {

        },

        mounted() {

        },

        beforeMounted() {

        },

        created() {
        },

        beforeDestroy() {
        },

        watch: {
            value: function (newVal, oldVal) {

            }
        }


    }
</script>

<style>

</style>
<style scoped>


    .PictureMaskWindow {
        width: 100%;
        height: 100%;
        border-left: 1px solid lightgray;
        border-right: 1px solid lightgray;
        background-color: transparent;
        font-family: 微軟正黑體,Microsoft JhengHei,Zawgyi-one;
    }

        .PictureMaskWindow .Header {
            position: relative;
            text-align: left;
        }
    
    .PictureItemListContainer
    {
        border:none;

    }

        .PictureItemListContainer .PictureItemList {
            height: auto;
            align-items:center;
            display:flex;
            align-items:stretch;
        }

    .PictureItemListContainer .PictureItemList .PictureItem {
        width: 100%;
        text-align: center;
        justify-content: center;
        position:relative;
    }

    .PictureItemListContainer .PictureItemList .PictureItem IMG{
        max-width:100%;
        max-height:100%;
        width:auto;
        position:static;
    }

            .PictureItemListContainer .PictureItemList .Description:empty{
                display:none;
            }

            .PictureItemListContainer .PictureItemList .Description {
                position: absolute;
                bottom: 0px;
                left: 0%;
                width: 100%;
                font-size: 12px;
                background-color: rgba(0,0,0,0.6);
                padding: 10px;
                color: white;
            }

            .CloseDialogButton {
                position: absolute;
                right: 5px;
                top: 5px;
                cursor: pointer;
                font-size: 15px;
                width: 28px;
                height: 28px;
                z-index: 30;
                background-color: transparent;
                border: none;
            }

    .PictureMaskWindow .Header  {
  
    }



    /deep/ .Pagination {
        display: block;
        text-align: left;

    }

 
    
    /deep/ .PictureMaskWindow .Pagination .PaginationButtonList {
        margin-top: 10px;
        display: block;
        padding-left: 5px;
        padding-right: 5px;
        margin-bottom: 5px;
    }

        /deep/ .PictureMaskWindow .Pagination .PaginationButtonList .PaginationButton {
            display: inline-block;
            margin-left: 2px;
            margin-right: 2px;
            border: 1px solid transparent;
            cursor: pointer;
            padding-left: 2px;
            padding-right: 2px;
            background-color:#f0f0f0;
        }

      /deep/ .PictureMaskWindow .Pagination .PaginationButtonList .PaginationButton.Current {
          background-color: yellow;
          color:black;
      }

    .PictureMask {
        position:relative;
    }

    /deep/ .PagingButton.Disabled{
        opacity:0.3;
    }
    
    /deep/ .PagingButton.Previous {
        z-index: 10;
        width: 20px;
        display: block;
        position: absolute;
        top: 0%;
        left: 1%;
        height: 100%;
        background-image: url(/static/Image/PrevWhite.png);
        background-position: center;
        background-repeat: no-repeat;
        background-size: 100% auto;
        cursor: pointer;
    }


    /deep/ .PagingButton.Next {
        z-index: 10;
        width: 20px;
        display: block;
        position: absolute;
        top: 0%;
        right:1%;
        height: 100%;
        background-image: url(/static/Image/NextWhite.png);
        background-position: center;
        background-repeat: no-repeat;
        background-size: 100% auto;
        cursor:pointer;
    }

 </style>
